import React from 'react'
import ProcessBar from '../../../components/global/charts/ProcessBar';
import { useNavigate } from 'react-router-dom';

const TransactionCard = ({ title, data }) => {
    const navigate = useNavigate();
    return (
        <>
            <div>
                {title && <p className='font-medium text-lg mb-4'>{title}</p>}
                <div>
                    <div className={`grid divide-x-2 ${data?.length > 2 ? "grid-cols-3" : "grid-cols-2"}`}>
                        {data?.map((item, index) => (
                            <div key={index} className='flex flex-col items-center gap-2 px-1'>
                                <div className='flex flex-col items-center gap-3 cursor-pointer' onClick={() => item?.navigate && navigate(item.navigate)}>
                                    <div className={`${item?.bgColor} p-1 w-8 h-8 rounded-lg flex items-center justify-center`}>{item?.icon}</div>
                                    <p className='text-xl mt-2'>{item?.count || 0}</p>
                                </div>
                                <p className='text-gray-500 text-center cursor-pointer' onClick={() => item?.navigate && navigate(item.navigate)}>{item?.name || ''}</p>
                            </div>
                        ))}
                    </div>

                    <div className='mt-5'>
                        <ProcessBar data={data} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransactionCard;
